export default function DSA_Merge_Sort_Time() {
  return <div>DSA_Merge_Sort_Time Component</div>;
}
